












































import { Component, Vue, Provide, Prop, Watch } from "vue-property-decorator";

@Component({
  name: "CalllogList"
})
export default class CalllogList extends Vue {
  @Prop() ContactTwoContactList!: any; // 联系人二列表

  @Provide() private inputKeyWord: any = ''; // 关键字
  @Provide() private originList: any = this.ContactTwoContactList.filter((item:any) => item.name != '' && item.lastcalltime >= 1688140800000); // 初始化list
  @Provide() private searchList: any = []; // 搜索后的list

  private onSearch(list:any, keyWord:string) {
    this.searchList = keyWord ? 
      list?.filter((item:any) => this.onFilter(item,keyWord)) 
    : list;
  }

  private onreplace(val:any) {
    return val.toLowerCase().replace(/á/gi,'a').replace(/ñ/gi,'n').replace(/é/gi,'e').replace(/í/gi,'i').replace(/ú/gi,'u').replace(/ó/gi,'o')
  }

  private onFilter(item:any,keyWord:any) {
    return (this.onreplace(item.name)).indexOf(this.onreplace(keyWord)) != -1
  }

private timeFormatDay = time => {
  if(!time) return ''
  let t = new Date(time);
  let year = t.getFullYear();
  let month = ("0" + (t.getMonth() + 1)).slice(-2);
  let day = ("0" + t.getDate()).slice(-2);
  return `${year}-${month}-${day}`;
}

private timeFormat = time => {
  if (!time) {
    return time;
  }
  let date = new Date(time);
  let month = this.addZero(date.getMonth() + 1);
  let day = this.addZero(date.getDate());
  var yearMonthDay = date.getFullYear() + "-" + month + "-" + day;
  var hoursMS =
    this.addZero(date.getHours()) +
    ":" +
    this.addZero(date.getMinutes()) +
    ":" +
    this.addZero(date.getSeconds());
  return yearMonthDay + " " + hoursMS;
}

private addZero = val => {
  if (val < 10) {
    val = "0" + val
  }
  return val
}

  @Watch("inputKeyWord")
  oninputKeyWordChanged(newValue: any) {
    this.inputKeyWord = newValue;
    this.onSearch(this.originList, this.inputKeyWord)
  }

  private onViewAll() {
    this.searchList = this.ContactTwoContactList;
  }

  private created() {
    this.searchList = this.originList;
  }
  private closeAction() {
    this.$emit("closeAction", false);
  }
}
